document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[data-origem-add]');
  if (!form) return;
  e.preventDefault();
  const btn = form.querySelector('button');
  btn.disabled = true;
  const label = btn.textContent;
  btn.textContent = 'Adicionando...';
  try {
    const addResponse = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
    if (!addResponse.ok) {
      const error = await addResponse.json().catch(() => ({}));
      throw new Error(error.description || error.message || 'Erro ao adicionar ao carrinho');
    }
    const cart = await (await fetch('/cart.js')).json();
    // Carrinho zerado renderiza o badge vazio para o CSS :empty escondê-lo (nunca mostra "0").
    const count = cart.item_count > 0 ? String(cart.item_count) : '';
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = count; });
    btn.textContent = 'Adicionado ✓';
  } catch {
    btn.textContent = 'Erro, tente de novo';
  }
  setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 1600);
});

/* ==========================================================================
   Página de produto (Task 7)
   ========================================================================== */

const ORIGEM_PDP_ROOT = '[data-origem-pdp]';

/** Atualiza o contador de itens do header a partir de /cart.js. */
async function origemRefreshCartCount() {
  try {
    const cart = await (await fetch('/cart.js')).json();
    const count = cart.item_count > 0 ? String(cart.item_count) : '';
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = count; });
  } catch {
    /* contador é só cosmético: se falhar, a página segue utilizável */
  }
}

/* --- Galeria: miniaturas trocam o slide ativo (desktop) ------------------- */
document.addEventListener('click', (e) => {
  const thumb = e.target.closest('[data-origem-thumb]');
  if (!thumb) return;
  const gallery = thumb.closest('[data-origem-gallery]');
  if (!gallery) return;
  const id = thumb.getAttribute('data-origem-thumb');

  gallery.querySelectorAll('[data-origem-thumb]').forEach((el) => {
    const active = el === thumb;
    el.classList.toggle('is-active', active);
    if (active) {
      el.setAttribute('aria-current', 'true');
    } else {
      el.removeAttribute('aria-current');
    }
  });

  gallery.querySelectorAll('[data-origem-slide]').forEach((slide) => {
    slide.classList.toggle('is-active', slide.getAttribute('data-origem-slide') === id);
  });
});

/* --- Stepper de quantidade ------------------------------------------------ */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-origem-qty]');
  if (!btn) return;
  const form = btn.closest('form');
  const input = form && form.querySelector('[data-origem-qty-input]');
  if (!input) return;
  const step = parseInt(btn.getAttribute('data-origem-qty'), 10) || 0;
  const next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
  input.value = String(next);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('change', (e) => {
  const input = e.target.closest('[data-origem-qty-input]');
  if (!input) return;
  const value = parseInt(input.value, 10);
  input.value = String(!value || value < 1 ? 1 : value);
});

/* --- CTA "Comprar agora": adiciona ao carrinho e vai para o carrinho ------ */
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[data-origem-buy]');
  if (!form) return;
  e.preventDefault();

  const btn = form.querySelector('.origem-pdp__cta');
  const label = btn ? btn.textContent : '';
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Adicionando...';
  }

  try {
    const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || error.message || 'Erro ao adicionar ao carrinho');
    }
    await origemRefreshCartCount();
    window.location.href = '/cart';
  } catch {
    if (btn) {
      btn.textContent = 'Erro, tente de novo';
      setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 1800);
    }
  }
});

/* A barra flutuante reaproveita o form principal, para não duplicar a lógica. */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-origem-stickybuy-cta]');
  if (!btn) return;
  const root = btn.closest(ORIGEM_PDP_ROOT);
  const form = root && root.querySelector('form[data-origem-buy]');
  if (!form) return;
  if (typeof form.requestSubmit === 'function') {
    form.requestSubmit();
  } else {
    form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }
});

/* --- Caixa de CEP ---------------------------------------------------------
   Visual apenas: monta o resultado com os valores configurados no tema.
   A integração real de frete (Correios / transportadora) entra aqui, trocando
   o bloco abaixo por uma chamada ao endpoint de cotação e usando a resposta
   no lugar de `data-shipping-price` / `data-delivery-estimate`.
   -------------------------------------------------------------------------- */
document.addEventListener('input', (e) => {
  const input = e.target.closest('[data-origem-cep-input]');
  if (!input) return;
  const digits = input.value.replace(/\D/g, '').slice(0, 8);
  input.value = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
});

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-origem-cep-submit]');
  if (!btn) return;
  const box = btn.closest('[data-origem-cep]');
  if (!box) return;
  const input = box.querySelector('[data-origem-cep-input]');
  const result = box.querySelector('[data-origem-cep-result]');
  if (!input || !result) return;

  const digits = input.value.replace(/\D/g, '');
  result.hidden = false;

  if (digits.length !== 8) {
    result.classList.add('is-error');
    result.textContent = 'Digite um CEP válido';
    return;
  }

  const price = box.getAttribute('data-shipping-price') || 'Frete grátis';
  const estimate = box.getAttribute('data-delivery-estimate') || '';
  result.classList.remove('is-error');
  result.innerHTML = '';
  const strong = document.createElement('strong');
  strong.textContent = price;
  result.appendChild(strong);
  result.appendChild(document.createTextNode(estimate ? ` — entrega em ${estimate}` : ''));
});

/* --- Barra flutuante: aparece quando o CTA principal sai da tela ---------- */
function origemInitStickyBuy(root) {
  const bar = root.querySelector('[data-origem-stickybuy]');
  const anchor = root.querySelector('[data-origem-cta-anchor]');
  if (!bar || !anchor) return;

  bar.hidden = false;
  if (!('IntersectionObserver' in window)) return;

  if (root.origemStickyObserver) root.origemStickyObserver.disconnect();
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      // Só mostra depois que o CTA passou para cima da viewport, nunca no topo da página.
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', scrolledPast);
    });
  }, { threshold: 0 });
  observer.observe(anchor);
  root.origemStickyObserver = observer;
}

/* --- Troca de variante via Section Rendering API -------------------------- */
let origemVariantRequest = 0;

async function origemSelectVariant(root, url) {
  const sectionId = root.getAttribute('data-section-id');
  const wrapper = document.getElementById(`shopify-section-${sectionId}`);
  if (!sectionId || !wrapper) return;

  const quantityInput = root.querySelector('[data-origem-qty-input]');
  const quantity = quantityInput ? quantityInput.value : '1';
  const target = new URL(url, window.location.origin);
  const fetchUrl = new URL(target.pathname, window.location.origin);
  fetchUrl.searchParams.set('variant', target.searchParams.get('variant'));
  fetchUrl.searchParams.set('section_id', sectionId);

  const ticket = ++origemVariantRequest;
  root.classList.add('is-loading');

  try {
    const response = await fetch(fetchUrl.toString());
    if (!response.ok) throw new Error('Falha ao carregar a variante');
    const html = await response.text();
    if (ticket !== origemVariantRequest) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.querySelector(ORIGEM_PDP_ROOT);
    if (!fresh) throw new Error('Section sem conteúdo de produto');

    const current = wrapper.querySelector(ORIGEM_PDP_ROOT);
    if (!current) throw new Error('Section atual não encontrada');
    current.replaceWith(fresh);

    const newQuantityInput = fresh.querySelector('[data-origem-qty-input]');
    if (newQuantityInput) newQuantityInput.value = quantity;

    window.history.replaceState({}, '', target.toString());
    origemInitPdp(fresh);
  } catch {
    window.location.href = url;
  } finally {
    root.classList.remove('is-loading');
  }
}

document.addEventListener('click', (e) => {
  const pill = e.target.closest('[data-variant-url]');
  if (!pill) return;
  const root = pill.closest(ORIGEM_PDP_ROOT);
  if (!root) return;
  e.preventDefault();
  if (pill.classList.contains('is-selected')) return;
  origemSelectVariant(root, pill.getAttribute('data-variant-url'));
});

/* --- Bootstrap ------------------------------------------------------------ */
function origemInitPdp(root) {
  if (!root) return;
  origemInitStickyBuy(root);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(ORIGEM_PDP_ROOT).forEach(origemInitPdp);
});

// O editor de temas recria a section inteira ao mudar um setting.
document.addEventListener('shopify:section:load', (e) => {
  e.target.querySelectorAll(ORIGEM_PDP_ROOT).forEach(origemInitPdp);
});
